import {
  Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnDestroy,
  OnChanges, SimpleChanges, SimpleChange
} from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  RequirementDO,
  /* Document Manager */
  AppConfig,
  EntityDocumentDO,
  AppMetadataHandler,
  UserInfoService,
} from 'app';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

/* Document Manager */
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { forkJoin, Observable, Observer } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
//import {RequestMethod, ResponseContentType} from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentManagerDataService } from './document-manager-data.service';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';

import * as moment from 'moment/moment';
declare var Tiff: any;
@Component({
  selector: 'app-bill-details-advanced',
  templateUrl: './bill-details-advanced.component.html',
  styleUrls: ['./bill-details-advanced.component.scss']
})
export class BillDetailsAdvancedComponent implements OnInit {

  constructor(
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private userInfoService: UserInfoService,
    /* Document Manager */
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private msg: NzMessageService,
    private appConfig: AppConfig,
    public appMetadataHandler: AppMetadataHandler,
    private docManDataService: DocumentManagerDataService,
    ) { }

    private _IO = null;
    @Input() transactionState: string;
    @Input()
    set IO(value: any) {
        this._IO = value;
        //this.labReports = this.getLabReportsFromRequirements();
        //this.clientDoList=this.getClientDOlistWithRole(this._IO)
        //this.lifeInsured = value;
        // if (this._IO != null) {
        //     this.policyIO = this.getDOName(this._IO);
        //     console.log("policy IO in underwriting worksheet", JSON.stringify(this.policyIO));
        // }

    };

    getDOName(IO) {
        console.log(IO)
        if (IO)
            return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
        else
            null
    }

    get IO() {
        return this._IO;
    }
    
  // ngOnInit() {
  //   this.OCRprocessBill();
  //   this.importSelected();
  // }

  /* Dropdown and Table Items */
  OCR_Result = [];
  OCR_Result_old = [
    {test: 'OPD Charges', result:'969,500.00', unit: true, checked:true },
    {test: 'CSSD', result:'19,923.00', unit: true, checked:true},
    {test: 'Registration and Admission Fee', result:'', unit: true, checked:true},
    {test: 'Doctor Fees', result:'266,000.00', unit: false, checked:true},
    {test: 'E.C.G', result:'3,000.00', unit: false, checked:true},
    {test: 'Echocardiography', result:'15,000.00', unit: false, checked:true},
    {test: 'Endoscopy', result:'5,753.00', unit: false, checked:true},
    {test: 'Medical Supply', result:'3,818.26.00', unit: false, checked:true},
    {test: 'Theatre Charges', result:'9,926.56', unit: false, checked:false},
    {test: '--', result:'99,650.00', unit: false, checked:false},
    {test: 'Pharmacy', result:'426,995.19', unit: false, checked:false},
    {test: 'Physiotherapy', result:'426,995.19', unit: false, checked:false},
    {test: 'Radiology', result:'42,310.00', unit: false, checked:false},
  ];
  bills = [
    {id:1, expanded: false},
    {id:2, expanded: false},
  ];
  bills_child = [];

  /* IMAGES (DUMMY CODE --- MUST RECODE FOR PRODUCTION) */
  // fileList = [
  //   {
  //     uid: '1',
  //     name: 'billA982.png',
  //     status: 'done',
  //     url: "/assets/images/demo/hospital-bill-sample.jpg",
  //   },
  //   {
  //     uid: '2',
  //     name: 'bill202F982.png',
  //     status: 'done',
  //     url: "/assets/images/demo/hospital-bill-sample-2.jpg",
  //   },
  // ];
  // handlePreview = () => {
  //   /* CHECK ng_zorro documentation for this code */
  //   /* Make current image show in preview img src */
  //   this.toggleImage(); // dummy
  //   this.msg.success("Selected bill loaded into preview");
  // };
  /* END IMAGES */



  modalBill: boolean = false;
  //billImage = this.fileList[0].url;

  /* OCR PROCESS IMAGE */
  /* DEMO ONLY -- WRITE FN TO PROCESS OCR + WRITE CUSTOM LOGIC FOR NON-OVERWRITING TABLE DATA FIELDS */
  processingOCR: boolean = true;
  OCRprocessBill() {
    this.processingOCR = true;
    setTimeout(()=>this.processingOCR=false,1500);
  }
  toggleImage() {
    // this.billImage == this.fileList[0].url?
    //   this.billImage= this.fileList[1].url:this.fileList[0].url;
  }

  importSelected() {
    this.modalBill = false;
    //this.bills_child = Object.create(this.OCR_Result.filter(i=>i.checked==true));
    this.bills[0].expanded = true;
  }


  // getLabReportsFromRequirements(){
  //   let fetchedLabReports = [];
  //   if(this.IO && this.commonUtilty.isArrayIterable(this.IO.requirementDOs)){
  //     this.IO.requirementDOs.forEach(requirement => {
  //       //if(requirement.requirmentTypeCd == ""){
  //         fetchedLabReports.push(requirement);
  //       //}
  //     });
  //   }
  //   return fetchedLabReports;
  // }

  labReports1 = [];
  labReports = [
    {
      active: true,
      name: 'This is panel header 1',
      disabled: false,
      labData : [
        {
          test    : 'HDL Cholesterol',
          result   : '55',
          unit    : 'mg/dL',
          range: '60 - 40 mg/dL'
        },
        {
          test    : 'LDL Cholesterol',
          result   : '180',
          unit    : 'mg/dL',
          range: '130 - 159 mg/dL'
        },
        {
          test    : 'Triglycerides',
          result   : '172',
          unit    : 'mg/dL',
          range: '150 - 199 mg/dL'
        },
        {
          test    : 'Non-HDL-C',
          result   : '147',
          unit    : 'mg/dL',
          range: '130 - 159 mg/dL'
        },
        {
          test    : 'HbA1C',
          result   : '6.8',
          unit    : 'mmol/L',
          range: '4.4 - 5.9 mmol/L'
        },
        {
          test    : 'CRP',
          result   : '3.4',
          unit    : 'mg/L',
          range: '0 - 3 mg/L'
        }
      ]
    },
    {
      active: false,
      disabled: false,
      name: 'This is panel header 2',
      labData : []
    },
    {
      active: false,
      disabled: true,
      name: 'This is panel header 3',
      labData : []
    }
  ];


  currentRequirementObjToUploadLabReport;
  showUploadLabReportPopup(requirement){
    this.modalBill=true;
    this.currentRequirementObjToUploadLabReport = requirement;
  }

  /*********************************Document Related Code************************************/
  _requirements = [];
  @Input()
  set requirements(value: any) {
    this._requirements = value;
    //this.initDocumentData(this._inputDataForEdit, this._requirements);
  };
  get requirements() {
    return this._requirements
  }

  private _inputDataForEdit;
  @Input()
  set inputDataForEdit(value: any) {
    this._inputDataForEdit = value
  };
  get inputDataForEdit() {
    return this._inputDataForEdit;
  }
  @Input() RequirementEntityGuid: any;
  io: any = null;
  ioNominees: any = null;
  ioClients: any = null;
  ioStartDate: any = null; // Intimation Date (for date check)

  /* ====== MINI MODE () ===== */
  @Input() mode = "mini";
  @Input() heading: string = 'No heading provided'; // this will be used as heading in mini mode
  @Input() headingType: 'heading' | 'label' = 'heading'; // Heading or label for heading text
  /* If it is client specific */
  @Input() clientRefGuid: any = null;
  @Input() clientDO: any = null;

  /*  ====== Configs ====== */
  @Input() readonly: boolean = false;
  @Input() coreComponent: boolean = false; /* if Core, its EMITS() data to parent */
  @Input() enableDownload: boolean = false;
  @Input() entity: 'claim' | 'policy' = 'policy'; // Loose docs would be named as per primary entity
  @Input() visibility: 'public-only' | 'all' = 'all'; // Public-only will list only public files

  @Input() subTransactionGuids = []; // For Investigator flitering

  /* Show only 'public' documents for these roleCds */
  externalUsers: Array<string> = ["CLAIM_INVESTIGATION"];  // 'RoleCd's of all external users go here ,"SR_EXECUTIVE"

  /* App config vars & defaults */
  defaultVisibilityCd: string = "INTERNAL"; // This will be used as default for NEW upload and NEW requirement
  defaultVisibilityCdExternalUser: string = "EXTERNAL"; // This will be used as default for NEW upload and NEW requirement for an EXTERNAL USER
  defaultStatusCd: string = "IDENTIFIED";   // This will be used as default for NEW requirement
  userIsExternal: boolean = false;
  notSupportedText: string = "Please download document to view contents"; // Default text for non-supported file types. Use i18n

  //</editor-fold>

  /* Zero State */
  docManZeroState = {
    title: "No Requirements",
    message: "Please save to generate requirements",
    icon: 'paper-clip'
  };

  documentsFromServer: any; //complete list of documents from server (guid fetch)
  documentsFromServerMini: any; //complete list of documents from server (guid fetch) BACKUP as first loop filters above var
  documents: any;
  isReady: boolean = false;
  isProd: boolean = environment.production;
  looseDocsKey: string = 'LOOSE_DOCUMENTS';

  /* Internally used */
  documentCollection: any = []; /* this is filtered and emitted */
  documentCollectionLoose: any = [];

  /* Dropdowns */
  looseDocNewType: any = null;
  documentTypeCdDrodownCache: any;
  documentSubTypeCdDrodownCache: any;

  /* Internal */
  UiFilesList: any[] = []; // Must be array

  /* FORCE update document data upon uploading a new file */
  forceUpdateDocData(docData: any) {
    this.isReady = false;
    // Save Requirements
    this.saveRequirements();
    // Save Documents
    let documentDOs = this.extractDocumentDOs();
    // Append newly uploaded file data !!!
    if (docData) {
      let docNew = docData.body; // MUST pass `body` only as it's HTTP request
      documentDOs.push(docNew);
    }
    this.apiRequestService.postCallWithAPIMapper('documentSave', documentDOs).subscribe(d => {
      console.log("Document Save response", d);
      // Reload component & emit for other sub-views (Mini views)
      this.docManDataService.dataHasChanged(this.RequirementEntityGuid);
    });
    return;
    /* * /
    if (!this.readonly && this.mode != 'mini' && this.coreComponent) {
      if(!!documentDOs && documentDOs.length){
        this.apiRequestService.postCallWithAPIMapper('documentSave',documentDOs).subscribe(d=>{
          console.log("Document Save response",d);
          // Reload component
          this.docManDataService.dataHasChanged(this.RequirementEntityGuid);
        });
      }
    }
    /* */
  }


  /* Check Mandatory fields */
  stringNames: string = '';
  checkIfAllMandatoryReqsFilled() {
    this.stringNames = '';
    let allFilled = true;
    /* OVERRIDE ---- ERROR CHECKS ARE DONE BY SERVER * /
    return true;
    /* OVERRIDE */
    let allMandatoryReqs = this.documentCollection.filter(d => {
      return (String(d.requirements.mandatoryFl).toUpperCase() == "YES" && !this.isWaived(d.requirements.status))
    });
    allMandatoryReqs.forEach(d => {
      if (d.documents.length == 0) {
        allFilled = false;
        this.stringNames += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allFilled;
  }

  /* Check Waived off reason */
  stringNamesWavied: string = '';
  checkIfWaivedOffReasonGiven() {
    this.stringNamesWavied = '';
    let allPassed = true;
    let allDCwithWaivedOff = this.documentCollection.filter(d => { return this.isWaived(d.requirements.status) });
    allDCwithWaivedOff.forEach(d => {
      if (!d.requirements.remarks) { //Removed: !d.requirements.waviedOffReasonCd || {ref: Investigation revoke - blocker}
        allPassed = false;
        this.stringNamesWavied += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allPassed;
  }

  /* Check Waived off is applied only for waivable ones  */
  stringNamesWaviedOffWaivable: string = '';
  checkIfWaivedOffWaivable() {
    this.stringNamesWaviedOffWaivable = '';
    let allPassed = true;
    let allDCwithWaivedOff = this.documentCollection.filter(d => { return this.isWaived(d.requirements.status) });
    allDCwithWaivedOff.forEach(d => {
      let lookupSe = this.lookupRequirements.find(i => i.lookupKey == d.requirements.requirementCd);
      if (lookupSe && (lookupSe.lookupAddValue1 != 1 || lookupSe.lookupAddValue1 != "1")) {
        allPassed = false;
        this.stringNamesWaviedOffWaivable += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allPassed;
  }

  /* Dates Mandatory Check: Ignore for IDENTIFIED & ORDERED alone */
  stringNamesDateMandatory: string = '';
  checkIfDateEnteredForNonIdentifiedReqs() {
    this.stringNamesDateMandatory = '';
    let allPassed = true;
    let allDCthatAreNotIdentifiedOrOrdered = this.documentCollection.filter(d => { return !(this.isIdentified(d.requirements.status) || this.isOrdered(d.requirements.status)) && !(d.requirements.requirementCd == this.looseDocsKey) && (null !== d.requirements.status) });
    allDCthatAreNotIdentifiedOrOrdered.forEach(d => {
      if (!d.requirements.receivedDt) {
        allPassed = false;
        this.stringNamesDateMandatory += "'" + this.sanitizeName(d.requirements.requirementCd) + "' ";
      }
    });
    return allPassed;
  }

  /* Check Mandatory fields */
  stringNamesInv: string = '';
  checkIfAllInvestigatorReqFilled() {
    this.stringNamesInv = '';
    let allFilled = true;
    let allMandatoryReqs = this.documentCollection.filter(d => { // First, filter Requirements to match our case
      return (d.requirements.visibilityCd == 'EXTERNAL')
    });
    allMandatoryReqs.forEach(d => { // Next, check validity of documents based on above filter
      if (!(this.isReceived(d.requirements.status))) { // || d.documents.length==0
        allFilled = false;
        this.stringNamesInv += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allFilled;
  }

  //</editor-fold>  Items

  addUploadRowLooseDocs() {
    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    if (!environment.production && !this.appMetadataHandler.featureFlags.allowEmptyReqEntityGuid) {
      if (!documentCollectionObj['requirements'].entityGuid) {
        console.log('Current Transaction Payload');
        console.log(this.inputDataForEdit);

        //throw "EnitityGuid for Requirement added is NULL, Please send valid Input of RequirementEntityGuid to DocumentManagerComponent in" + this.getParentComponentName();
      }
      if (!this.documentCollection) {
        console.log('Current Transaction Payload');
        console.log(this.inputDataForEdit);
        //throw `documentCollection Not initialized properly in ${this.getCurrentComponentName()} which is placed in ${this.getParentComponentName()}`
      }
    }

    /* NEW ROW: Loose Docs */
    documentCollectionObj['requirements'].requirementCd = this.looseDocsKey;  //"LOOSE_DOCUMENTS" made an @Input() var
    documentCollectionObj['requirements'].appliesToCd = "SYSTEM";
    documentCollectionObj['requirements'].mandatoryFl = "NO";

    if (!this.documentCollection)
      this.documentCollection = [];
    this.documentCollection.push(documentCollectionObj)
  }


  /* Add */
  addUploadRowCustomReq(reqCd: string, mandatory: false) {
    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    /* NEW ROW: Custom Requirement */
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    documentCollectionObj['requirements'].requirementCd = reqCd;
    documentCollectionObj['requirements'].appliesToCd = "SYSTEM";
    documentCollectionObj['requirements'].mandatoryFl = mandatory ? "YES" : "NO";
    documentCollectionObj['requirements'].clientId = null;
    if (!this.documentCollection)
      this.documentCollection = [];
    this.documentCollection.push(documentCollectionObj)
  }
  removeUploadRow() {
    alert('Cannot remove requirements');
    return false;
  }

  /* Add loose doc row */
  addUploadRowCustomReqLooseDec(reqCd: string, appliesToCd: string, mandatory?: false) {
    if (!reqCd || !appliesToCd) {
      this.msg.error(`Please select a document type`);
      return;
    }
    /* Does this row already exist? */
    if (this.documentCollectionLoose.filter(dc => { return dc.requirements.requirementCd == reqCd && dc.requirements.appliesToCd == appliesToCd }).length) {
      this.msg.error(`'` + this.sanitizeName(appliesToCd) + `' already exists`);
      return;
    }

    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    /* NEW ROW: Custom Requirement */
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    documentCollectionObj['requirements'].requirementCd = reqCd;
    documentCollectionObj['requirements'].appliesToCd = appliesToCd;
    documentCollectionObj['requirements'].mandatoryFl = mandatory ? "YES" : "NO";
    documentCollectionObj['requirements'].clientId = null;
    if (!this.documentCollectionLoose || !this.documentCollectionLoose.length)
      this.documentCollectionLoose = [];
    this.documentCollectionLoose.push(documentCollectionObj)
  }

  /* Get Lookups */
  lookupsToBind = ['documentCd', 'requirementStatusCd', 'docVisibilityCd', 'waivedOffReasonCd', 'requirements', 'userRequirements', 'claimStageCd'];
  lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind);

  /* Local Cache (as we need to use lookups in TS) */
  lookupsLocal: any = [];
  lookupRequirements: any = [];
  lookupUserRequirements: any = [];
  item

  claimIOSub$: any = null;
  guidInstance: string = this.randomString(5);
  userId: string = 'USER';
  userLoggedIn: any = null;
  userLoggedInRoles: Array<any> | null = [];

  ngOnInit() {
    //this.subscribeToParentEvent();
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px';
    
    console.log('DocuMan _inputDataForEdit ===============', this._inputDataForEdit);

    if (!this.inputDataForEdit) this.inputDataForEdit = [];

    this.documents = this.inputDataForEdit;
    this.inputDataForEdit = null; // Unset to save mem

    /* Initialize Upload Vars */
    this.initUploadVars();
    this.labReports = this._requirements;

    /* No requirements ? Get RequirementDO (POLICY INITIALIZATION CASE) */
    if ((Array.isArray(this._requirements) && this._requirements.length == 0) && this.RequirementEntityGuid) {
      let pathVariables = [];
      pathVariables.push(this.RequirementEntityGuid);
      this.apiRequestService.getCallWithAPIMapper('requirementFetchByEntityGuid', null, null, pathVariables).subscribe(data => {
        if (data) {
          this.initDocumentData([], data);
        }
      });
    }

    /* Initialize MAIN onInit() */
    this.initDocumentData(this.documents, this._requirements);

    /* test */
    //this.fetchFile("/usr/local/tomcat/C:/policy-documents/TEST_TETSSUB_null.png");
    console.log(`DOCUMENT_MANAGER_INIT() for ${this.entity} ${this.RequirementEntityGuid} with docs, reqs`, this.documents, this._requirements);

    /* Subscribe to service for data changes */
    this.docManDataService.fetchDataCanges().subscribe((d) => {
      if (d && (d == this.RequirementEntityGuid)) {
        console.log("DATA CHANGE DETECTED from DocumentManagerDataService: ", d);
        this.initDocumentData(this.documents, this._requirements);
      }
    });

    /* Get lookups for manipulating in TS */
    this.lookupDataService.getLookup('requirements').subscribe(res => {
      this.lookupRequirements = res;
    });
    this.lookupDataService.getLookup('userRequirements').subscribe(res => {
      this.lookupUserRequirements = res;
    });

    /* Subscribe to save/submit */
    if (this.claimIOSub$) this.claimIOSub$.unsubscribe();
    this.claimIOSub$ = this.interactService.claimIOForDocumentManagerSubject$.subscribe(io => {
      if (this.entity !== 'claim') {
        console.log(`Document Manager: claimIOForDocumentManagerSubject$ --> Re-init() REJECTED FOR entity-type ${this.entity}`);
        return;
      }
      else if (!io || (io && !io['requirementDOs'])) {
        console.log("Document Manager: claimIOForDocumentManagerSubject$ --> Subscription does not have valid requirementDOs. Skipping Re-init()");
        return;
      }
      else {
        console.log("Document Manager: claimIOForDocumentManagerSubject$ --> trying re-init() with data", io['requirementDOs']);
        /* Re-init() guid in case of IO input - guid not received from @Input, but coming on save of INT/REG/ADJ/INV  */
        let DOName = this.commonUtilty.getDOName(io)
        let ioRx = io[DOName]
        if (!this.RequirementEntityGuid) {
          this.RequirementEntityGuid = ioRx['guid'];
          console.log("Setting GUID for DM from claimIOForDocumentManagerSubject$", this.RequirementEntityGuid);
        }
        if (ioRx && Array.isArray(ioRx['intimationDt']) && ioRx['intimationDt'].length >= 3) {
          this.setStartDate(ioRx['intimationDt']);
        }
        /* Re-init component */
        let data = [];
        this.io = io;
        console.log("IO IO", this.io);
        if (io) {
          this._requirements = io['requirementDOs'];
          this.ioNominees = this.commonUtilty.extractClientDOListFromIOGeneric(this.io, 'NOMINEE');
        } else {
          this.ioNominees = [];
        }
        this.ioClients = this.io.clientDOs ? this.io.clientDOs : [];
        console.log("IO NOMINEES", this.ioNominees);
        console.log("IO CLIENTS", this.ioClients);
        this.initDocumentData(data, this._requirements);
      }
    });

    /* Logged-in User's info */
    this.userId = this.userInfoService.getUserId();
    this.userLoggedIn = this.userInfoService.getUserInfo();
    this.userLoggedInRoles = [];
    console.log("Current Logged-in User:", this.userLoggedIn);
    if (this.userLoggedIn && this.userLoggedIn.userRoleDOList) {
      if (this.userLoggedIn.userRoleDOList.length) {
        this.userLoggedInRoles = this.userLoggedIn.userRoleDOList.map(r => r.roleId); // extract roles
      }
    }
    console.log("Current Logged-in User's Roles:", this.userLoggedInRoles);

    /* Check if logged in user is an External User */
    this.externalUsers.forEach(u => {
      if ((this.userLoggedInRoles.indexOf(u) > -1)) {
        this.userIsExternal = true;
      }
    });
    console.log("Current Logged-in User is EXTERNAL USER ", this.userIsExternal);


  } // end ngOnInit()

  transformToNZobj(item) {
    let url = item.imageURL || item.url;
    let filename = this.guessFileName(url);
    return {
      uid: item.id,
      name: filename,
      status: item.status || 'done',
      url: url,
      thumbUrl: item.thumb || 'https://cdn2.iconfinder.com/data/icons/ourea-icons/256/File_-_Default_256x256-32.png'
    }
  }

  private initDocumentData(data, requirements) {
    this.isReady = false;

    /* "NEW" cases */
    if (!this.RequirementEntityGuid) { // || !requirements
      this.isReady = true;
      return;
    }

    if (this.clientRefGuid) this.mode = "mini"; /* if clientRefGuid is passed via @Input(), show mini mode */

    /* Set Document Collection */
    this.documentCollection = [];

    /* Copy Requirements */
    if (requirements) {
      requirements.forEach((req, index) => {
        //delete req.requirementChaserDOs;
        this.documentCollection[index] = {};
        this.documentCollection[index]['requirements'] = req;
        this.documentCollection[index]['documents'] = [];
        this.documentCollection[index]['UiFilesList'] = [];
      });
    }

    /* Additionally, append Loose Documents to the end */
    this.addUploadRowLooseDocs();

    /* Data exists? SET it -- Reserved for Future use */
    if (data) {
    }

    /* Get all documents of this Entity using its `guid` */
    let guid = this.RequirementEntityGuid;

    let pathVariables = [];
    pathVariables.push(guid || null);

    this.apiRequestService.getCallWithAPIMapper('documentFetchByEntityGuid', null, null, pathVariables).subscribe(data => {

    // this.apiRequestService.getCallWithAPIMapper(`documentFetchByEntityGuid/${guid}`).subscribe(data => {
      //this.documentsFromServerMini = JSON.parse(JSON.stringify(data));
      this.documentsFromServer = data;
      this.documents = data;
      /* All documents from server */
      if (this.documentsFromServer.length) {

        this.documentCollection.forEach((d, index) => {
          // Set default visibility for Requirement Visibility
          if (!d.requirements.visibilityCd) d.requirements.visibilityCd = this.defaultVisibilityCd;

          let category = d.requirements.requirementCd;
          let clientGuid = d.requirements.clientRefGuid;
          d.documents = this.documentsFromServer.filter(i => i.documentTypeCd == category && i.clientRefGuid == clientGuid); //CHANGE LOGIC HERE
          // Remove used docs from main list (filter !=) to keep only loose_docs in the end
          this.documentsFromServer = this.documentsFromServer.filter(i => !(i.documentTypeCd == category && i.clientRefGuid == clientGuid)); //CHANGE LOGIC HERE

          /* Set date */
          if (d.requirements.receivedDt) {
            this.dateArray[index] = new Date(d.requirements.receivedDt);
          }
          else this.dateArray[index] = null;

        });

        /* Sort by Document's ID (server returns reverse order!; so that wont work for us as we use doc[0] for saving meta data) */
        this.documentCollection.forEach((d, index) => {
          if (d.documents.length) {
            d.documents.sort(this.dynamicSort('id'));
          }
        });


        /* Put all unassigned docs in LOOSE_DOCS */
        let indexLooseDocs = this.documentCollection.length - 1;
        this.documentCollection[indexLooseDocs].documents.push(...this.documentsFromServer);
        this.fileList=this.documentCollection[indexLooseDocs].documents;
        /* Transform all LOOSE_DOCS for custom multi-level view */
        this.documentCollectionLoose = [];
        /* we are creating fake 'requirements' for loose doc categories (UI purposes alone) */
        let looseDocReqs = this.documentCollection[indexLooseDocs].requirements;
        let allLooseDocs = this.documentCollection[indexLooseDocs].documents || [];

        allLooseDocs.forEach((doc, index) => {

          let category = doc.documentTypeCd;
          let subCategory = doc.documentSubTypeCd;

          /* If already processed, continue */
          if (this.documentCollectionLoose.filter(dc => { return dc.requirements.requirementCd == category && dc.requirements.appliesToCd == subCategory }).length) {
            //CHANGE LOGIC HERE (loose document hierarchy filter)
          }
          else {
            /* Create a new fake requirement w/ its document set */
            /* NEW Requirement (User for UI alone) */
            let documentCollectionObj = {
              'requirements': new RequirementDO(),
              'documents': [],
              'UiFilesList': [],
            };
            documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
            documentCollectionObj['requirements'].requirementCd = category;
            documentCollectionObj['requirements'].appliesToCd = subCategory;
            documentCollectionObj['requirements'].mandatoryFl = "NO";
            documentCollectionObj['requirements'].clientId = null;
            /* Add the documents */
            let docs = allLooseDocs.filter(i => { return i.documentTypeCd == category && i.documentSubTypeCd == subCategory }); //CHANGE LOGIC HERE (loose document hierarchy filter)
            // Remove used docs from main list (filter !=)
            //allLooseDocs = allLooseDocs.filter(i=>{return i.documentTypeCd!==category && i.documentSubTypeCd!==subCategory}); //CHANGE LOGIC HERE (loose document hierarchy filter)
            documentCollectionObj['documents'] = docs;
            this.documentCollectionLoose.push(documentCollectionObj);
          }

          /* Sort by Document's ID (server returns reverse order!; so that wont work for us as we use doc[0] for saving meta data) */
          this.documentCollectionLoose.forEach((d, index) => {
            if (d.documents.length) {
              /* Sort */
              d.documents.sort(this.dynamicSort('id'));
              /* Set date for loose docs */
              if (d.documents[0].documentRecievedDt) {
                this.dateArrayLoose[index] = new Date(d.documents[0].documentRecievedDt);
              }
              else this.dateArrayLoose[index] = null;
            }
            else {
              this.dateArrayLoose[index] = null;
            }
          });

        });


        /* Take out all private docs for EXTERNAL USERS */
        if (this.userIsExternal || this.visibility == 'public-only') {
          /* Filter out all documents that are not public */
          /* NOTE: CSS-based disable done as of now; reason: whole array needs to be sent back to server for changes */
        }


        /* Transform and Set * /
        for( let i=0; i<this.documentsFromServer.length; i++ ) {
          //this.documentCollection[0]['UiFilesList'].push(this.transformToNZobj(this.documentsFromServer[i]));
          this.documentCollection[0]['documents'].push(this.documentsFromServer[i]);
        }
        /* */

      }

      /* Set meta and process dates for missing ones */
      this.documentCollection.forEach((d, index) => {
        // Set default visibility for Requirement Visibility
        if (!d.requirements.visibilityCd) d.requirements.visibilityCd = this.defaultVisibilityCd;
        /* Set date */
        if (d.requirements.receivedDt) {
          this.dateArray[index] = new Date(d.requirements.receivedDt);
        }
        else this.dateArray[index] = null;
      });

      

      /* Init Mini View */
      this.initMiniView();

      /* Enable UI display */
      setTimeout(() => {
        this.isReady = true;
        /* Init Mini View */
        this.initMiniView();
      }, 512);

    });

  }

  fetchedOCRDataList = [];
  fetchOCRData(){
    let pathVariables = [];
    pathVariables.push(this.RequirementEntityGuid);
    this.apiRequestService.getCallWithAPIMapper('labtestFetchByEntityGuid', null, null, pathVariables).subscribe(data => {
      if (data) {
        console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
        console.log(data);
        this.fetchedOCRDataList = [...data];
      }
    });
  }

  temp_OCRResult = [
		{
			"parentObject": null,
			"versionId": null,
			"guid": "f281511f-c5d3-4c85-bb54-ce561475bf5d",
			"createdDt": 1668769234715,
			"updatedDt": 1668769234715,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 93,
			"testCd": "Hemoglobin",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "g/dl",
			"value": "9.0",
			"referenceMinValue": 12,
			"referenceMaxValue": 12,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "312e7852-dbb9-4d88-9d6f-05578afd0be7",
			"createdDt": 1668769234715,
			"updatedDt": 1668769234715,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 94,
			"testCd": "Packed Cell Volume (PCV)",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "%",
			"value": "46.70",
			"referenceMinValue": 36,
			"referenceMaxValue": 36,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "3629e475-1ba1-4598-bda7-84a467cdbcdc",
			"createdDt": 1668769234715,
			"updatedDt": 1668769234715,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 95,
			"testCd": "RBC Count",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "mill/mm3",
			"value": "4.48",
			"referenceMinValue": 3.8,
			"referenceMaxValue": 3.8,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "05e727aa-a58b-4811-9f45-ddaf3f310663",
			"createdDt": 1668769234731,
			"updatedDt": 1668769234731,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 96,
			"testCd": "MCV",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "fL",
			"value": "104.20",
			"referenceMinValue": 83,
			"referenceMaxValue": 83,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "a0d32e31-c3bb-4a9b-b27d-f5afa6b5a653",
			"createdDt": 1668769234731,
			"updatedDt": 1668769234731,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 97,
			"testCd": "MCH",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "pg",
			"value": "29.70",
			"referenceMinValue": 27,
			"referenceMaxValue": 27,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "0056c36a-a742-454a-9c0d-b584f59f5872",
			"createdDt": 1668769234731,
			"updatedDt": 1668769234731,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 98,
			"testCd": "MCHC",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "g/d",
			"value": "28.50",
			"referenceMinValue": 31.5,
			"referenceMaxValue": 31.5,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "3c11533e-a700-4272-92ef-bd4f9e8ee246",
			"createdDt": 1668769234746,
			"updatedDt": 1668769234746,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 99,
			"testCd": "Red Cell Distribution Width (RDW)",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "%",
			"value": "16.50",
			"referenceMinValue": null,
			"referenceMaxValue": null,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "4b0b6597-aa17-4ff4-a443-9e66351e2f6d",
			"createdDt": 1668769234746,
			"updatedDt": 1668769234746,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 100,
			"testCd": "Total Leukocyte Count (TLC)",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "4.86",
			"referenceMinValue": 4,
			"referenceMaxValue": 4,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "b016cfa7-263a-4ad1-839b-30bbfd6691d1",
			"createdDt": 1668769234746,
			"updatedDt": 1668769234746,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 101,
			"testCd": "Differential Leucocyte Count (DLC)",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": null,
			"value": null,
			"referenceMinValue": null,
			"referenceMaxValue": null,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "0a9d5506-9e98-4cda-a75f-5137b3b67e3f",
			"createdDt": 1668769234746,
			"updatedDt": 1668769234746,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 102,
			"testCd": "Segmented Neutrophils",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "1%",
			"value": "38.40",
			"referenceMinValue": 40,
			"referenceMaxValue": 40,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "02335aed-c18e-4f95-a299-3e207ed3d6a3",
			"createdDt": 1668769234764,
			"updatedDt": 1668769234764,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 103,
			"testCd": "Lymphocytes",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "%",
			"value": "45.10",
			"referenceMinValue": 20,
			"referenceMaxValue": 20,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "d6437ef6-b6b4-4e13-8721-f07744e1cb3c",
			"createdDt": 1668769234764,
			"updatedDt": 1668769234764,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 104,
			"testCd": "Monocytes",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "%",
			"value": "12.80",
			"referenceMinValue": 2,
			"referenceMaxValue": 2,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "629d7c01-80b2-4891-9b7d-31b4a914d6d9",
			"createdDt": 1668769234764,
			"updatedDt": 1668769234764,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 105,
			"testCd": "Eosinophils",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "%",
			"value": "2.90",
			"referenceMinValue": 1,
			"referenceMaxValue": 1,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "b3b9b8f3-9bd0-43ed-9d09-636bbe44d783",
			"createdDt": 1668769234780,
			"updatedDt": 1668769234780,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 106,
			"testCd": "Basophils",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "%",
			"value": "0.80",
			"referenceMinValue": null,
			"referenceMaxValue": null,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "5d7e1901-2096-4d3f-a7a7-5121f11bb045",
			"createdDt": 1668769234780,
			"updatedDt": 1668769234780,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 107,
			"testCd": "Absolute Leucocyte Count",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": null,
			"value": null,
			"referenceMinValue": null,
			"referenceMaxValue": null,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "eedf076a-1f57-4ff9-ba39-6fbe2aeb7c24",
			"createdDt": 1668769234780,
			"updatedDt": 1668769234780,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 108,
			"testCd": "Neutrophils",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "1.87",
			"referenceMinValue": 2,
			"referenceMaxValue": 2,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "39c9c869-5fa1-4eb8-904d-6531e3ac9e81",
			"createdDt": 1668769234780,
			"updatedDt": 1668769234780,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 109,
			"testCd": "Lymphocytes",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "2.19",
			"referenceMinValue": 1,
			"referenceMaxValue": 1,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "8f3a6f85-618c-4209-91c6-a02be528fbb1",
			"createdDt": 1668769234795,
			"updatedDt": 1668769234795,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 110,
			"testCd": "Monocytes",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "0.62",
			"referenceMinValue": 0.2,
			"referenceMaxValue": 0.2,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "991c6136-cafb-4fa1-96af-c1e338aa5566",
			"createdDt": 1668769234795,
			"updatedDt": 1668769234795,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 111,
			"testCd": "Eosinophils",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "0.14",
			"referenceMinValue": 0.02,
			"referenceMaxValue": 0.02,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "1a0a0a66-2045-45bf-81ad-338056dbec2b",
			"createdDt": 1668769234795,
			"updatedDt": 1668769234795,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 112,
			"testCd": "Basophils",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "0.04",
			"referenceMinValue": 0.02,
			"referenceMaxValue": 0.02,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "f2060d21-253d-43ca-a9cd-fe4270a8272f",
			"createdDt": 1668769234795,
			"updatedDt": 1668769234795,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 113,
			"testCd": "Platelet Count",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "thou/mm3",
			"value": "349.0",
			"referenceMinValue": 150,
			"referenceMaxValue": 150,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "030a75de-9753-40de-a894-94e355bdd79d",
			"createdDt": 1668769234811,
			"updatedDt": 1668769234811,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 114,
			"testCd": "Mean Platelet Volume",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "fL",
			"value": "9.5",
			"referenceMinValue": 6.5,
			"referenceMaxValue": 6.5,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		},
		{
			"parentObject": null,
			"versionId": null,
			"guid": "034bf1e3-b730-4924-8dfd-392d0b7806c5",
			"createdDt": 1668769234811,
			"updatedDt": 1668769234811,
			"createdUser": "Vrushali",
			"updatedUser": "Vrushali",
			"baseCompanyCd": "MMS",
			"versionNum": 0,
			"workflowStatusCd": null,
			"shareByRegionalOfc": null,
			"id": 115,
			"testCd": "ESR",
			"typeCd": null,
			"measureValue": null,
			"measureUnitCd": "mm/hr",
			"value": "10",
			"referenceMinValue": 0,
			"referenceMaxValue": 0,
			"referenceMeasureUnitCd": null,
			"testDt": null,
			"testUpdateDt": null,
			"objectName": "LabTestResultDO",
			"baseAdditionalFields": null,
			"referenceNum": null
		}
	];
	
  currentOCRDocumentGuid;
  saveUpdateOCRData(documentGuid?){
    if(documentGuid) this.currentOCRDocumentGuid = documentGuid;
    let body = {
      "documentGuid":this.currentOCRDocumentGuid,
      "labTestDOs":this.OCR_Result && this.OCR_Result.length >0 ? this.OCR_Result : this.temp_OCRResult
    }
    this.apiRequestService.post('labtest/save', body).subscribe(resp => {
      if(resp){
        console.log(resp);
        this.OCR_Result = resp && resp[0] ? this.commonUtilty.deepCopy(resp[0]['labTestResults']) : []
      }
    });
  }

  extractRequirementDOs() {
    let requirementDOs = [];
    if (this.documentCollection && this.documentCollection.length > 0)
      this.documentCollection.forEach(document => {
        if (document['requirements'].requirementCd !== this.looseDocsKey) requirementDOs.push(document['requirements']);
      });
    return requirementDOs;
  }

  extractDocumentDOs() {
    /* Fetches the freshest docs list to emit */
    let docDOAll = [];
    let docDOLoose = [];
    if (this.documentCollection && this.documentCollection.length > 0)
      this.documentCollection.forEach(document => {
        if (document['documents'].length) docDOAll.push(...document['documents']);
      });
    if (this.documentCollectionLoose && this.documentCollectionLoose.length > 0)
      this.documentCollectionLoose.forEach(document => {
        if (document['documents'].length) docDOLoose.push(...document['documents']);
      });
    /* no need to merge, as it is by reference */
    let documentDO = docDOAll;
    return documentDO;
  }

  ngOnDestroy(): void {
    console.log("DocumentManagerComponent ngOnDestroy() DESTROYED!!!");
  }

  /* File Operations */
  fileListTemp: NzUploadFile[] = [];
  uploading: boolean = false;
  fileUploadEndpoint: string;
  fileFetchEndpointRAW: string;
  fileFetchEndpoint: string;

  /* Tab Index */
  tabIndex: number = 0;

  initUploadVars() {
    /* API Endpoints */
    this.fileUploadEndpoint = this.appConfig.baseApiPath + 'saveMultipart';
    this.fileFetchEndpointRAW = 'fetchMultipart';
    this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
    /* Set loose_docs key */
    switch (this.entity) {
      case 'policy': this.looseDocsKey = "POLICY_DOCUMENTS"; break;
      case 'claim': this.looseDocsKey = "CLAIM_DOCUMENTS"; break;
      default: this.looseDocsKey = "LOOSE_DOCUMENTS"; break;
    }
  }

  fileUploadBefore = (file: NzUploadFile, fileList): boolean => {
    this.preUploadImgChecks(file).subscribe(
      n => {
        if (n) { //n = true => All passed
          this.fileListTemp = []; //reset
          this.fileListTemp.push(file); //push
          this.fileUpload(); // handle upload & reset component
          return true;
        }
      },
      e => { return false },
      () => { return false }
    );
    return false; // We need to return false to nz-upload (else it will invoke onError())
  };
  fileRemove = (file: NzUploadFile): boolean => {
    alert('Cannot remove uploaded file. Please upload new file to replace');
    return false;
  };

  /* Image Upload checks */
  preUploadImgChecks = (file: NzUploadFile) => {
    return new Observable((observer: Observer<boolean>) => {
      /* Bypass checks * /
      observer.next(true);
      observer.complete();
      return;
      /* */
      /* Max File Size */
      const maxFileSize = 5; /* in MB */

      /* Supported file types */
      let fileName = file.name;
      let fileType = file.type;

      let isSupportedFileType =
        file.type.includes('image') ||
        file.type.includes('video') ||
        file.type.includes('audio') ||
        file.type.includes('pdf');

      /* New check for 'supported file' upload [overrides previous check] */
      if (this.guessFileType(fileName) !== "File") isSupportedFileType = true;

      console.log("File Name, File type: ", fileName, " ----- ", fileType);

      if (!isSupportedFileType) {
        this.msg.error(`Unsupported file type. Please select a Document, Image, Video or Audio file`);
        observer.complete();
        this.initDocumentData(this.documents, this._requirements); //reset
        return;
      }
      const fileSizeOK = file.size / 1024 / 1024 < maxFileSize;
      if (!fileSizeOK) {
        this.msg.error(`Document must smaller than ${maxFileSize} MB`);
        observer.complete();
        this.initDocumentData(this.documents, this._requirements); //reset
        return;
      }
      observer.next(isSupportedFileType && fileSizeOK);
      observer.complete();
      return;
    });
  };


  sel_documentTypeCd: any = '';
  sel_documentSubTypeCd: any = '';
  sel_visibilityCd: any = '';
  sel_clientRefGuid: any = '';
  /* setUploadParams() is required because there no way to set/pass dynamic values to nzBeforeUpload */
  setUploadParams(req, tabIndex: number = 0, clientRef: any = false) {

    this.RequirementEntityGuid = req.entityGuid;
    this.sel_documentTypeCd = req.requirementCd;
    this.sel_documentSubTypeCd = req.appliesToCd;
    this.sel_clientRefGuid = clientRef ? clientRef : req.clientRefGuid;
    this.sel_visibilityCd = req.visibilityCd || this.defaultVisibilityCd; // Set default visibility
    if (this.userIsExternal) this.sel_visibilityCd = this.defaultVisibilityCdExternalUser; // Force change visibility for external users to PUBLIC
    this.tabIndex = tabIndex;
  }

  /* Core function that handles upload */

  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    'hash': '7h1nk[)j',
  });

  /* Handles the uploading of file */
  fileUpload(): void {
    const url = this.fileUploadEndpoint;
    const formData = new FormData();
    this.uploading = true;
    this.isReady = false; // loading ...
    this.msg.loading('Uploading document', { nzDuration: 1000 });
    // Set Data & Defaults for the Uploaded file
    let lastFilename = '', lastFiletype = '';
    this.fileListTemp.forEach((file: any) => { lastFilename = file.name; lastFiletype = file.type; });
    const obj = {
      entityGuid: this.RequirementEntityGuid,
      documentTypeCd: this.sel_documentTypeCd,
      documentSubTypeCd: this.sel_documentSubTypeCd,
      guid: this.randomString(10),
      entityImageName: lastFilename, entityImageMimeType: lastFiletype,
      clientRefGuid: this.clientRefGuid ? this.clientRefGuid : this.sel_clientRefGuid ? this.sel_clientRefGuid : null,
      visibilityCd: this.userIsExternal ? this.defaultVisibilityCdExternalUser : this.defaultVisibilityCd, // this.sel_visibilityCd, // Set default PRIVATE status to newly uploaded file
    };
    console.log("Doc Save POST Object");
    console.table(obj);
    const options = {
      reportProgress: true,
      headers: this.headers,
    };
    formData.append('json', JSON.stringify(obj));
    // Attach File(s) [1 in this case]
    this.fileListTemp.forEach((file: any) => {
      formData.append('file', file);
    });
    const req = new HttpRequest('POST', url, formData, options);
    this.http
      .request(req)
      .pipe(filter(e => e instanceof HttpResponse))
      .subscribe(
        (e: {}) => {
          this.uploading = false;
          this.msg.success('Upload successful');
          // this.initDocumentData(this.documents, this._requirements); // Re-initialize doc data
          /// EDITED
          // this.docManDataService.dataHasChanged(this.RequirementEntityGuid); // Use this
          this.forceUpdateDocData(e); // this calls dataHasChaged
          this.saveUpdateOCRData(e['body']['guid']);
          this.fileListTemp = [];
        }, (e) => {
          this.uploading = false;
          this.initDocumentData(this.documents, this._requirements); // Re-initialize doc data
          this.msg.error('Upload failed');
        }
      );
  }

  modalFilePreview: boolean = false;
  previewDataStream: any = null;
  previewDataStreamUnsanitized: string = '';
  previewFileUrl: string = '';
  fileIsBeingDownloaded: boolean = false;

  /* Retrieve file, perform actions on data  */
  fetchFile(url, action: string = 'return'): void | boolean | any {

    // Basic checks and resets
    this.previewDataStream = null;
    this.previewFileUrl = url;
    if (!url) return false;

    let body = { "imageURL": url };
    let guessedFilename = this.guessOriginalFileNameFromImgURL(url);

    /* No need to fetch file if file is not previewable */
    if ('preview' == action && !this.fileIsPreviewable(url)) {
      this.previewDataStream = null;
      this.modalFilePreview = true; //open the modal anyway, and show "download"
      return false;
    }

    this.modalFilePreview = ('preview' == action);

    this.fileIsBeingDownloaded = true;

    /* Get file contents (bin) */
    this.http.post<Blob>(this.fileFetchEndpoint, body, {
      headers: this.headers,
      responseType: 'blob' as 'json'
    })
      .pipe(map(res => {
        if (!res) { console.log(" ----- EMPTY FILE RESPONSE ----- "); return; }
        switch (action) {
          case 'download':
            this.fileIsBeingDownloaded = false;
            this.downloadFile(res, guessedFilename);
            break;
          case 'return':
            this.fileIsBeingDownloaded = false;
            return res;
          case 'preview':
            let me = this;
            /* Special Case Handling: TIFF, TIF using JS decoder */
            if (['tif', 'tiff'].includes(this.guessFileExtension(guessedFilename))) {
              let reader = new FileReader();
              reader.readAsArrayBuffer(res);
              reader.onloadend = function () {
                let tiff = new Tiff({ buffer: reader.result }); // parse, decode
                let canvas = tiff.toCanvas(); // convert decoded image to HTML canvas
                setTimeout(() => {
                  let querySelectorElement = '#tiff-canvas';
                  let nodeList = document.getElementById(querySelectorElement);
                  if (nodeList && nodeList.childNodes[0]) nodeList.removeChild(nodeList.childNodes[0]);
                  document.querySelector(querySelectorElement).appendChild(canvas);
                }, 500);
                me.previewDataStream = '  ';
                me.fileIsBeingDownloaded = false;
                me.modalFilePreview = true;
                return;
              };
              return;
            }
            let base64data;
            let reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = function () {
              base64data = reader.result;
              base64data = base64data.split(',')[1];
              /* Decide Charset/Encoding */
              let charsetEncoding = 'data:image/jpeg;base64';
              switch (me.guessFileType(url)) {
                case 'Image':
                  charsetEncoding = 'data:image/jpeg;base64';
                  break;
                case 'Video':
                  charsetEncoding = 'data:video/mp4;base64';
                  break;
                case 'Audio':
                  charsetEncoding = 'data:audio/ogg;base64';
                  break;
                case 'Document':
                  charsetEncoding = 'data:application/' + me.guessFileExtension(url) + ';base64';
                  break;
                case 'Html':
                  charsetEncoding = 'data:text/html;base64';
                  break;
              }
              if ('pdf' == me.guessFileExtension(url))
                me.previewDataStream = me.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;
              else if ('html' == me.guessFileExtension(url)) {
                let url = decodeURIComponent(escape(window.atob(base64data)));
                me.previewDataStream = me.sanitizer.bypassSecurityTrustHtml(url);
              }
              else
                me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(charsetEncoding + "," + base64data);
              me.previewDataStreamUnsanitized = charsetEncoding + "," + base64data;
              //me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res));
              me.fileIsBeingDownloaded = false;
              me.modalFilePreview = true;
            };
            break;
        }
      }))
      .subscribe(d => { }, e => { console.log("Document Fetch http err", e) });
  }

  /* =========== File name Helpers (guessers) =========== */
  /* @thinkdj 30 July 2019 */
  guessFileName(url) {
    if (!url) { return ''; }
    const character = (url.indexOf('\\') > -1) ? '\\' : '/';
    return url.substring(url.lastIndexOf(character) + 1);
  }
  guessFileExtension(url) {
    const filename = this.guessFileName(url);
    return String(filename.substring(filename.lastIndexOf('.') + 1)).toLowerCase();
  }
  guessOriginalFileName(fileObj) {
    if (typeof fileObj !== 'object') { return ''; }
    return (fileObj.entityImageName) ? fileObj.entityImageName : this.guessFileName(fileObj.imageURL);
  }
  guessOriginalFileNameFromImgURL(imgUrl) {
    if (!this.documentsFromServerMini || !this.documentsFromServerMini.length) return '';
    const fileObj = this.documentsFromServerMini.find(d => d.imageURL === imgUrl); /* unfiltered copy of documentsFromServer */
    if (typeof fileObj === 'object') { return this.guessOriginalFileName(fileObj); }
    return '';
  }

  /* Guess filetype IF extension is not found in file URL (Eg: filenet case) */
  guessFileExtensionFromMIME(url) {
    // (1) Take from entityImageMimeType (2) Split `/` (3) Return extension
  }

  /* Generic function to guess file type */
  /* NOW ALSO USED as for finding 'supported files' *** */
  guessFileType(url): string {
    let extension = url;
    if (url && url.length > 4) extension = this.guessFileExtension(url);
    /* Find file type */
    if (['jpg', 'png', 'x-png', 'jpeg', 'pjpeg', 'jfif', 'gif', 'tiff', 'tif', 'bmp', 'webp'].includes(extension)) return "Image";
    else if (['pdf', 'doc', 'docx'].includes(extension)) return "Document";
    else if (['mp4', 'mov', 'avi', 'mpeg', 'webm'].includes(extension)) return "Video";
    else if (['mp3', 'wav', 'ogg'].includes(extension)) return "Audio";
    else if (['xls', 'xlsx', 'xlt', 'xltx', 'xlsm', 'xlsb', 'xla', 'xlam', 'xltm'].includes(extension)) return "Sheet";
    else if (['zip', 'gz', 'rar', 'rar5'].includes(extension)) return "Archive";
    else if (['eml', 'msg'].includes(extension)) return "Email";
    else if (['html', 'htm'].includes(extension)) return "HTML";
    return "File"; // un-supported
  }
  fileIsPreviewable(url): boolean {
    let supportedFormats = [ // Add all supported formats here
      'jpg', 'png', 'jpeg', 'jfif', 'gif', 'bmp', 'webp', //Images
      'tif', 'tiff', // TIFF images (requires decoder plugin)
      'mp4', 'mov', 'avi', 'mpeg', 'webm', // Videos
      'mp3', 'wav', 'ogg', //Audio
      'pdf', // PDF Doc
      'html', 'htm', // HTML Files
    ];
    let extension = this.guessFileExtension(url);
    return supportedFormats.includes(extension);
  }

  /* Emulate a download-file click */
  downloadFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.jpg';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
    return true;//url;
  }

  handleError(e) { console.log(e) };

  /* Sanitize */
  sanitizeName(string, append: any = false, refGuid: any = false): string {
    if (string) {
      //string = "ID_PROOF_NOMINEE";
      /* Check if lookup exists for key */
      let lookupSe = this.lookupRequirements.find(i => i.lookupKey == string);
      //console.log("LOOK",string,lookupSe);
      if (lookupSe) {
        string = lookupSe.lookupValue;
        //console.log("--- using ",string);
      } else {
        /* Continue with sanitization (DISABLED: 15th July 2020 after review) */
        string = String(string).replace("_", " ");
        // string = this.capitalizeWords(string);
        // string = this.autoCapitalize(string);
        string = this.strSpecialCases(string);
      }
    }

    if (append) {
      string = string + " (" + append + ")";
    }

    if (refGuid && this.ioNominees) {
      let client = this.ioNominees.find(i => i.guid == refGuid);
      if (client) string = string + " - " + this.capitalizeWords(String(client['name']));
    }

    return string;
  }
  capitalizeWords = function (str: string) {
    str = str.toLowerCase();
    return str.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
  };
  autoCapitalize = function (str) {
    let arr = str.split(" ");
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].length < 3) arr[i] = arr[i].toUpperCase();
      /* Undo some known words */
      if (['OF', 'BY', 'THE'].includes(arr[i])) arr[i] = arr[i].toLowerCase();
    }
    return arr.join(" ");
  };
  strSpecialCases = function (str) {
    if (str == "CLAIM DOCUMENTS") str = "Claim Documents";
    if (str == "POLICY DOCUMENTS") str = "Policy Documents";
    let arr = str.split(" ");
    for (let i = 0; i < arr.length; i++) {
      if (['id'].includes(arr[i].toLowerCase())) arr[i] = arr[i].toUpperCase();
    }
    return arr.join(" ");
  };

  randomString(len, charSet?) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
      var randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  }

  /* Custom XHR Requests (UNUSED) * /
  customXHRReq = (item: UploadXHRArgs) => {
    const formData = new FormData();
    // tslint:disable-next-line:no-any
    formData.append('file', item.file as any);
    formData.append('id', '1000');
    const req = new HttpRequest('POST', item.action, formData, {
      reportProgress: true,
      withCredentials: true
    });
    // `Subscription` to nz-upload
    return this.http.request(req).subscribe((event: HttpEvent<{}>) => {
      if (event.type === HttpEventType.UploadProgress) {
        if (event.total > 0) {
          // tslint:disable-next-line:no-any
          (event as any).percent = event.loaded / event.total * 100;
        }
        item.onProgress(event, item.file);
      } else if (event instanceof HttpResponse) {
        item.onSuccess(event.body, item.file, event);
      }
    }, (err) => {
      // item.onError(err, item.file);
      console.log(err);
    });
  };
  customHugeXHRReq = (item: UploadXHRArgs) => {
    const size = item.file.size;
    const chunkSize = parseInt((size / 3) + '', 10);
    const maxChunk = Math.ceil(size / chunkSize);
    const reqs = Array(maxChunk).fill(0).map((v: {}, index: number) => {
      const start = index * chunkSize;
      let end = start + chunkSize;
      if (size - end < 0) {
        end = size;
      }
      const formData = new FormData();
      formData.append('file', item.file.slice(start, end));
      formData.append('start', start.toString());
      formData.append('end', end.toString());
      formData.append('index', index.toString());
      const req = new HttpRequest('POST', item.action, formData, {
        withCredentials: true
      });
      return this.http.request(req);
    });
    return forkJoin(...reqs).subscribe(resules => {
      item.onSuccess({}, item.file, event);
    }, (err) => {
      item.onError(err, item.file);
    });
  };
  /* */

  // Lookups
  // lookupsToBind = ['documentTypeCd','documentSubTypeCd'];
  // lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)



  /* ================== DATA FORMATS INTERCHANGE ================== */
  base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  //var uintArray = Base64Binary.decode(base64_string);
  //var byteArray = Base64Binary.decodeArrayBuffer(base64_string);
  //**blob to dataURL**
  blobToDataURL(blob, callback) {
    var a = new FileReader();
    //a.onload = function(e) {callback(e.target.result);}
    a.readAsDataURL(blob);
  }
  blobToBase64 = function (blob, callback) {
    var reader = new FileReader();
    reader.onload = function () {
      var dataUrl = String(reader.result);
      var base64 = dataUrl.split(',')[1];
      callback(base64);
    };
    reader.readAsDataURL(blob);
  };
  dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    var byteString = atob(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to an ArrayBuffer
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var _ia = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
      _ia[i] = byteString.charCodeAt(i);
    }
    var dataView = new DataView(arrayBuffer);
    var blob = new Blob([dataView], { type: mimeString });
    return blob;
  }


  @Input() requirementCd: string = '';

  documentCollectionMiniMode: any = [];

  /* MINI VIEW Init() */
  /* This initializes the sub-data needed for MINI view; also sets the data arrays accordingly */
  initMiniView() {
    if (this.mode == 'mini') {

      /* Check if all required inputs exists */
      if ((!this.requirementCd)) {
        console.log('Document Manager: ERROR!!! MINI mode --> All required inputs are mandatory !!!!!');
        return;
      }

      /* Get from existing doc list */
      let docSubListForMini = this.documentCollection.filter(i => i.requirements.requirementCd == this.requirementCd);
      /* If it doesnt exist, inject it */
      if (!docSubListForMini || docSubListForMini.length == 0) {
        docSubListForMini = this.addUploadRowCustomReq(this.requirementCd, false);
      }
      docSubListForMini = this.documentCollection.filter(i => i.requirements.requirementCd == this.requirementCd);
      console.log("Setting Data for Mini View ----", docSubListForMini);
      this.documentCollectionMiniMode = docSubListForMini;

      this.documentCollectionMiniMode.forEach((d, index) => {
        let category = d.requirements.requirementCd;
        d.documents = this.documentsFromServerMini.filter(i => i.documentTypeCd == category && i.clientRefGuid == this.clientRefGuid); //CHANGE LOGIC HERE (Filter data for MINI view)
        // Remove used docs from main list (filter !=)
        ///this.documentsFromServer = this.documentsFromServer.filter(i=>i.documentTypeCd!==category && i.clientRefGuid!==this.clientRefGuid); //CHANGE LOGIC HERE (Filter data for MINI view)
      });


    }
  }

  /* Force string conversion */
  toStr(val) {
    return String(val);
  }


  /* ====================== OCR  =========================== */

  @Input() ocrVerification: any = null;

  ngOnChanges(changes: SimpleChanges) {
    const ocrVer: SimpleChange = changes.ocrVerification;
    if (!!ocrVer) {
      //console.log('OCR DATA Prev: ', ocrVer.previousValue);
      console.log('OCR DATA Changed: ', ocrVer.currentValue);
      this.OCRInputModelsHaveChanged();
    }
  }

  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: false,
    hidePreviewIconInNonImage: false
  };
  fileList=[];
  fileList_old = [{
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };


  /* If any of the inputs that affect OCR component has changed, we need to reset it */
  OCRReady = true;
  OCRInputModelsHaveChanged() {
    this.OCRReady = false;
    this.setDataToBeVerifiedByOCR();
    setTimeout(() => { this.OCRReady = true }, 100);
  }

  /* OCR */
  OCRfileImage: string = 'https://bse2nse.com/images/cancelled_cheque.png'; /* Dummy Default for DEMO */
  handleFileUploadChange(e: any) {
    console.log("handleFileUploadChange", e.type);
    switch (e.type) { /* e.type：start, progress, success, removed */
      case 'removed':
        this.OCRInputModelsHaveChanged();
        break;
      case 'error':
      case 'success':
        this.setDataToBeVerifiedByOCR();
        this.OCRfileImage = e.file.url || e.file.thumbUrl;
        break;
    }
  }
  OCRverificationData: Array<any> = [];
  setDataToBeVerifiedByOCR() {
    this.OCRverificationData = this.ocrVerification;
  }


  dynamicSort = function (property) {
    return function (a, b) {
      return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
  };

  /* Update visibility with new one for all files matching type,subType */
  updateVisibility = function (documentTypeCd, documentSubTypeCd, visibilityCd) {
    this.documentCollection.forEach((d, index) => {
      if (d.documents.length) {
        for (let i = 0; i < d.documents.length; i++) {
          if (d.documents[i].documentTypeCd == documentTypeCd && d.documents[i].documentSubTypeCd == documentSubTypeCd) {
            d.documents[i].visibilityCd = visibilityCd;
          }
        }
      }
    });
    this.dataHasChanged();
  };
  /* Update status with new one for all files matching type,subType */
  updateStatus = function (documentTypeCd, documentSubTypeCd, statusCd) {
    this.documentCollection.forEach((d, index) => {
      if (d.documents.length) {
        for (let i = 0; i < d.documents.length; i++) {
          if (d.documents[i].documentTypeCd == documentTypeCd && d.documents[i].documentSubTypeCd == documentSubTypeCd) {
            d.documents[i].documentStatusCd = statusCd;
          }
        }
      }
    });
    this.dataHasChanged();
  };
  /* Update Date */
  updateDate = function (documentTypeCd, documentSubTypeCd, date) {
    let dateVal = new Date(date).setHours(0, 0, 0, 0).valueOf();
    console.log("Setting date for set: ", documentTypeCd, documentSubTypeCd, date);
    this.documentCollection.forEach((d, index) => {
      if (d.documents.length) {
        for (let i = 0; i < d.documents.length; i++) {
          if (d.documents[i].documentTypeCd == documentTypeCd && d.documents[i].documentSubTypeCd == documentSubTypeCd) {
            d.documents[i].documentRecievedDt = dateVal
          }
        }
      }
    });
    this.dataHasChanged();
  };

  /* Received Date */
  dateArray: any = [];
  dateChange(date, index) {
    this.documentCollection[index]['requirements'].receivedDt = new Date(date).valueOf();
    this.dataHasChanged();
  }

  /* Loose Docs Received Date */
  dateArrayLoose: any = [];

  /* Simple change detection */
  dataChanged: boolean = false;
  dataHasChanged = function () {
    this.dataChanged = true;
  };

  /* Check if WAIVED */
  isWaived(i) {
    i = String(i).toLowerCase();
    return (i == 'waived' || i == 'waved'); // Possible values sent from server
  }
  /* Check if WAIVED */
  isOrdered(i) {
    i = String(i).toLowerCase();
    return (i == 'ordered' || i == 'orderd'); // Possible values sent from server
  }
  /* Check if IDENTIFIED */
  isIdentified(i) {
    i = String(i).toLowerCase();
    return (i == 'identified' || i == 'identified' || i == 'indentified'); // Possible values sent from server (yes, even 'indentified')
  }
  /* Check if RECEIVED */
  isReceived(i) {
    i = String(i).toLowerCase();
    return (i == 'received' || i == 'recieved'); // Possible values sent from server
  }

  /* Check if requirement is related to "nominee" or "client" */
  clientGuidToBeShown(cd) {
    return this.isNomineeRelated(cd) || this.isClientRelated(cd);
  }
  isNomineeRelated(cd) { return String(cd).toUpperCase().includes("NOMINEE") }
  isClientRelated(cd) { return String(cd).toUpperCase().includes("CLIENT") }
  isClaimantRelated(cd) { return String(cd).toUpperCase().includes("CLAIMANT") }

  /* NEW REQUIREMENT */
  unsavedNewRequirement: boolean = false;
  modalNewRequirement: boolean = false;
  newReqTemp: any = {
    userRequirement: null,
    statusCd: this.defaultStatusCd,
    visibilityCd: this.userIsExternal ? this.defaultVisibilityCdExternalUser : this.defaultVisibilityCd,
    identifedDt: new Date(),
    requestedDt: null,
    orderingNotes: null,
    remarks: null,
  };
  newReqTempBackup: any = Object.assign({}, this.newReqTemp); // Copy object for resetting

  createNewReq() {

    /* Null check */
    if (!this.newReqTemp.userRequirement) {
      this.msg.error(`Invalid Requirement specified`);
      return;
    }

    /* Check if same requirement already exists */
    if (this.documentCollection.filter((dc) => { return (dc.requirements.requirementCd == this.newReqTemp.userRequirement) }).length) {
      this.msg.error(`Requirement '` + this.sanitizeName(this.newReqTemp.userRequirement) + `' already exists`);
      return;
    }

    let identifiedDate = this.newReqTemp.identifedDt ? this.newReqTemp.identifedDt.valueOf() : new Date();

    let req = new RequirementDO();
    req.entityGuid = this.RequirementEntityGuid;
    req.requirementCd = this.newReqTemp.userRequirement;
    req.clientRefGuid = this.newReqTemp.clientRefGuid;
    req.status = this.newReqTemp.statusCd;
    req.identifiedBy = this.userId || "USER"; // Logged-in user's ID; defaults to "USER"
    req.appliesToCd = this.entity.toUpperCase(); // CLAIM
    /* Dates */
    req.identifedDt = identifiedDate;
    req.requestedDt = this.newReqTemp.requestedDt ? this.newReqTemp.requestedDt.valueOf() : identifiedDate; // Defaults to identified date
    /* Resolve By */
    req.resolveByStageCd = this.newReqTemp.resolveByStageCd;
    req.remarks = this.newReqTemp.remarks; // Remark (general)
    /* orderingNotes */
    req.orderingNotes = this.newReqTemp.orderingNotes; // Remark (in case of 'other' requirementCd)

    console.log("NEW REQUIREMENT: ", req);

    /* Create in Document Manager's structure * /
    let dc = {
      requirements: req,
      documents: [],
    };
    this.documentCollection.unshift(dc); // Insert to top
    /* */

    /* Reset variables */
    this.unsavedNewRequirement = true;
    this.modalNewRequirement = false; // Close modal
    this.isReady = false;

    /* Loader (pseudo) */
    this.msg.loading("Generating New Requirement", { nzDuration: 1000, nzAnimate: true, nzPauseOnHover: false });

    /* Save Requirements API Call */
    //this.saveRequirements(); // Changed to new api call below
    // Code copy-pasted again (for requirement/createUserReq) call
    this.apiRequestService.postCallWithAPIMapper('createUserReq', req).subscribe(respRequirements => {
      console.log("Requirement Save response", respRequirements);
      if (respRequirements) {
        console.log("Reqirement Save sucessful. Re-init() with new Reqs array (single req response inserted)");
        this._requirements.unshift(respRequirements); // Insert to top
        this.initDocumentData(null, this._requirements);
        /* RESET VARS */
        this.isSaving = false;
        this.unsavedNewRequirement = false;
        /* Reset ReqTemp */
        this.newReqTemp = Object.assign({}, this.newReqTempBackup); // Copy object for resetting
      }
    });
  }

  isSaving: boolean = false;
  /* Save both Requirements and Documents */
  saveReqsAndDocs() {

    /* VALIDATE OP before save */
    // let errorCount = this.validateOutput();
    // if (this.validationOutput.isInvalid) {
    //   this.validationOutput.errorDOs.forEach(eDO => {
    //     console.log('ERROR DO DOC MAN', eDO);
    //     this.msg.error(eDO.errorMsg);
    //   });
    //   return;
    // }

    this.msg.loading("Saving document details", { nzDuration: 1000, nzAnimate: true, nzPauseOnHover: false });
    this.saveRequirements();
    this.saveDocuments();
    this.isReady = false;
    this.dataChanged = false;
  }

  /* Save Requirements */
  saveRequirements() {
    this.isSaving = true;
    let req = this.extractRequirementDOs();
    if (!req) return;
    this.apiRequestService.postCallWithAPIMapper('requirementSave', req).subscribe(respRequirements => {
      console.log("Reqirement Save response", respRequirements);
      if (respRequirements) {
        console.log("Reqirement Save sucessful. Re-init() with new Reqs");
        this._requirements = respRequirements;
        let data = null;
        this.initDocumentData(data, this._requirements);
        /* RESET VARS */
        this.isSaving = false;
        this.unsavedNewRequirement = false;
      }
    });
  }

  /* Save Documents */
  saveDocuments() {
    this.isSaving = true;
    let documentDOs = this.extractDocumentDOs();
    if (!!documentDOs && documentDOs.length) {
      this.apiRequestService.postCallWithAPIMapper('documentSave', documentDOs).subscribe(d => {
        console.log("Document Save response", d);
        let data = null;
        this.initDocumentData(data, this._requirements);
        /* RESET VARS */
        this.isSaving = false;
      });
    }
  }

  /* Date Fns */
  disabledDate = (current: Date): boolean => {
    let today = moment(new Date());
    let currentDate = moment(current);

    /* Intimation date */
    if (this.ioStartDate) {
      return !(currentDate.isBetween(this.ioStartDate, today));
    }
    else {
      /* Future Date disable */
      let diff = today.diff(currentDate, 'days', true);
      return !(diff > 0);
    }
    /* PS: Using (!)NOT because we want to disable dates that is NOT part of criteria */
  };

  /* Set Start Date (intimation Date) */
  setStartDate(dateArr) {
    if (Array.isArray(dateArr) && dateArr.length >= 3) {
      this.ioStartDate = String(dateArr[0]) + "-" + String(dateArr[1]) + "-" + String(dateArr[2]);
      console.log("Setting ioStartDate ------ ", this.ioStartDate);
    }
  }


  /* Hide for External User */
  hideForExternalUser(req) {
    let shouldHide = false;
    if (this.userIsExternal) { // Applicable only for external user
      if (req.visibilityCd == 'EXTERNAL') shouldHide = false; //If external, dont hide
      if ((req.visibilityCd == 'INTERNAL') && !(this.subTransactionGuids.find(id => id == req.subTransactionGuid))) shouldHide = true; // If internal & subTransactionGuid not found, hide
    }
    return shouldHide;
  }



}
